/** Shared JSON → `contacts` row shape (browser and CLI). No Supabase client import. */

export type ContactImportJson = {
  name: string;
  email?: string;
  phone?: string;
  rolesSeen?: string[];
  legCount?: number;
};

export function normalizeContactImportRows(
  rows: ContactImportJson[]
): Array<{ name: string; email: string; phone: string; roles: string }> {
  return rows
    .map((r) => ({
      name: (r.name ?? "").trim(),
      email: (r.email ?? "").trim(),
      phone: (r.phone ?? "").trim(),
      roles: Array.isArray(r.rolesSeen) ? r.rolesSeen.join("; ") : "",
    }))
    .filter((r) => r.name.length > 0);
}
